import _ from 'lodash';
import {
  DYNAMIC_ISSUE_TYPES_MODEL,
  TABLE_MODEL_DYNAMIC_ISSUE_TYPES
} from '../jiraStats.model';
import AssigneesCell from './cell-components/AssigneesCell';
import EffortFteCell from './cell-components/EffortFteCell';
import EffortPercentCell from './cell-components/EffortPercentCell';
import FteCostCell from './cell-components/FteCostCell';
import KeyCell from './cell-components/KeyCell';
import { StyledCell } from './Row.style';
import ParentCell from '../../../Forecasting/ProjectProgression/ProgressionTable/useProgressionTable/table-layouts/cell-components/ParentCell';

export const getDynamicIssueTypesRows = ({ data, period, raCost }) => {
  return _.map(data, row => {
    const key = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.KEY);
    const name = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.NAME);
    const childrenCount = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.CHILDREN_COUNT);

    const effort = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.EFFORT);
    const effortFte = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.EFFORT_FTE);

    const assignees = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.ASSIGNEES);
    const parent = row?.[DYNAMIC_ISSUE_TYPES_MODEL.PARENT];
    const url = _.get(row, DYNAMIC_ISSUE_TYPES_MODEL.URL);

    return {
      ...row,
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.KEY_CELL]: (
        <KeyCell title={key} url={url} />
      ),
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.NAME_CELL]: (
        <StyledCell>{name}</StyledCell>
      ),
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.ASSIGNEES_CELL]: (
        <AssigneesCell assignees={assignees} />
      ),
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.PARENT_CELL]: (
        <ParentCell parent={parent} />
      ),
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.CHILDREN_COUNT_CELL]: (
        <StyledCell>{childrenCount}</StyledCell>
      ),
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.EFFORT_CELL]: (
        <EffortPercentCell effortPercent={effort} />
      ),
      [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.EFFORT_FTE_CELL]: (
        <EffortFteCell effortFte={effortFte} />
      ),
      ...(raCost.isEnabled
        ? {
            [TABLE_MODEL_DYNAMIC_ISSUE_TYPES.COST_FTE_CELL]: (
              <FteCostCell
                period={period}
                raCost={raCost}
                effortFte={effortFte}
              />
            )
          }
        : {})
    };
  });
};
